/* Agriwelt system wizard. Source: Shopify-Kit-Sync/wizard (build_theme.py). Do not edit here. */
(function () {
  "use strict";
  var R = window.KitRules, D = window.WizardDraw, TEXT = window.WizardText, SL = window.SensorLayer;

  // Part prices read from the shop (Admin API, ACTIVE products) on 22.10.2026. In the theme they come live from the products.
  var PRICES = {
    "AC01.01.03.02.000": 410, "AC01.01.04.03.000": 759, "AC01.01.04.04.100": 1190, "AC05.03.03.08.001": 109,
    "AC03.01.01.02.000": 120, "AC03.01.02.04": 124, "AC03.01.03.02.000": 122, "AC03.01.04.02.010": 129, "AC03.01.04.06.000": 150,
    "AC05.02.01.01.000": 37, "AC05.02.01.02.000": 44, "AC05.02.01.03.000": 51, "AC05.02.01.04.000": 58, "AC05.02.01.08.000": 69,
    "AC08.02.01.05.010": 118, "AC08.02.01.06.000": 24, "AC08.02.01.03": 15,
    // 3-pin layer, read 30.10.2026
    "AC02.02.08.05.000": 229, "AC05.03.08.08.000": 79, "AC05.03.08.09.000": 78, "AC03.02.02.01.000": 98, "AC06.01.01.01.000": 10,
    "AC06.01.02.01.000": 55, "AC06.01.02.02.000": 60, "AC06.01.02.03.000": 65, "AC03.03.02.01.000": 132, "AC02.05.01.00": 54,
    "AC05.02.04.20.000": 75, "AC05.02.04.22": 28, "AC05.02.04.01.000": 32, "AC05.02.04.02.000": 34, "AC05.02.04.03.000": 36, "AC05.02.04.04.000": 39
  };
  var WA = "436706567227", WA_SHOWN = "+43 670 6567227", MAIL = "info@agriwelt.com";
  var PAGE_URL = "https://agriwelt.com/pages/system-wizard";
  /* On the site the section hands over window.AW_WIZARD: live part prices and variant ids from the products,
     the page language and currency. Without it (the stand-alone mock-up) the snapshot above is used. */
  var SITE = window.AW_WIZARD || null, VARIANT = {}, CURRENCY = "EUR";
  if (SITE && SITE.wa) { WA = SITE.wa; WA_SHOWN = SITE.waShown || WA_SHOWN; MAIL = SITE.mail || MAIL; }
  if (SITE) {
    PRICES = {};
    (SITE.parts || []).forEach(function (p) { if (p && p.sku && p.available) { PRICES[p.sku] = +p.price; VARIANT[p.sku] = p.id; } });
    CURRENCY = SITE.currency || "EUR";
    if (SITE.pageUrl) PAGE_URL = SITE.pageUrl;
  }
  // The 3-pin layer's parts come from the storefront product JSON (prices in cents of the visitor's currency), then a re-render.
  function loadAuxParts() {
    if (!SITE || !SITE.auxHandles || !window.fetch) return;
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
    Promise.all(SITE.auxHandles.map(function (h) {
      return fetch(root + "products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      list.forEach(function (p) {
        (p && p.variants || []).forEach(function (v) { if (v.sku && v.available) { PRICES[v.sku] = v.price / 100; VARIANT[v.sku] = v.id; } });
      });
      if (st) render();
    });
  }
  var WA_SVG = '<svg aria-hidden="true" viewBox="0 0 24 24"><path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91A9.85 9.85 0 0 0 12.04 2zm5.8 14.03c-.24.68-1.43 1.3-1.97 1.35-.5.05-.98.24-3.3-.69-2.8-1.1-4.58-3.97-4.72-4.16-.13-.18-1.12-1.49-1.12-2.85 0-1.35.71-2.02.96-2.29.25-.27.55-.34.73-.34h.53c.17 0 .4-.06.62.48.24.56.8 1.94.87 2.08.07.14.12.3.02.48-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.56.16.27.71 1.17 1.52 1.9 1.05.93 1.93 1.22 2.2 1.36.27.14.43.12.59-.07.16-.18.68-.79.86-1.07.18-.27.36-.23.61-.14.25.09 1.58.75 1.85.88.27.14.45.2.52.32.07.11.07.66-.17 1.34z"/></svg>';

  /* Funnel for the ads (owner 22.10): every view, every step opened, whether the visitor moves down or back up,
     every change, every message. On the site these go to Shopify.analytics.publish like 'whatsapp_click';
     wa.me links are also caught by the site-wide WhatsApp conversion. */
  var EVENTS = window.awWizardEvents = [];
  /* Events go out only through Shopify's customer events; the pixel forwards them to GA4 and Ads and keeps
     the cookie consent (owner 23.10). Contract with the pixel, names and fields fixed:
       wizard_view {lang, from_link}  wizard_step {step, index, direction}  wizard_change {field, value}
       wizard_unknown {field, step}  wizard_ask {step, config}  wizard_share {config}
       wizard_cart {total, currency, config, check}
       wizard_leave {last_step, last_index, seconds, reached_price, outcome}
       wizard_fit {answer, lang, page} (the "does it fit" line under the result, owner 30.10)
     GA4 cuts a parameter at 100 characters: `config` is the first 100, the whole token rides in `config_full`. */
  var visit = { t0: Date.now(), step: "", index: 0, price: false, outcome: "none", left: false };
  var OUTCOME_RANK = { none: 0, share: 1, ask: 2, cart: 3 };
  function track(name, data) {
    var d = data || {};
    if ("total" in d) d.currency = CURRENCY;   // prices are the buyer's cart currency, not always EUR
    if (d.config && d.config.length > 100) { d.config_full = d.config; d.config = d.config.slice(0, 100); }
    if (OUTCOME_RANK[name] > OUTCOME_RANK[visit.outcome]) visit.outcome = name;
    var ev = { name: "wizard_" + name, data: d };
    EVENTS.push(ev);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev.name, ev.data); } catch (e) {}
  }
  // One leave event per visit, when the tab goes hidden (pagehide is unreliable on phones); coming back and leaving again sends nothing.
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState !== "hidden" || visit.left) return;
    visit.left = true;
    track("leave", { last_step: visit.step, last_index: visit.index, seconds: Math.round((Date.now() - visit.t0) / 1000),
                     reached_price: visit.price, outcome: visit.outcome });
  });
  var MACHINES = ["mounted", "trailed", "cartFront", "cartRear"];
  var PRODUCTS = ["seedOnly", "separate", "shared"];
  var TUBES = [25, 30, 32, 35, 50, "unknown"];
  var DISPLAYS = ["mini", "h5", "one"];

  function heads(n, o) { var a = []; for (var i = 0; i < n; i++) a.push({ o: o, c: [] }); return a; }
  // A box drill (gravity, no heads) has no heads: its list is empty and the rows are counted directly (owner 22.10).
  var DEFAULT = { machine: "trailed", product: "seedOnly", seed: heads(4, 9), fert: heads(2, 8), seedG: 24, fertG: 24,
                  seedTube: 32, fertTube: "same", display: "h5", width: "7,2", spacing: "20",
                  shafts: 0, shaft: "hex22", hop: 0, hopN: 1, turb: 0, speed: "auto" };
  var SHAFTS = ["hex22", "hex25", "sq17"], SPEEDS = ["auto", "gps", "iso", "drill", "cart"];

  var st, ui = { open: "machine", sel: { seed: 0, fert: 0 }, lang: "en" };

  /* ---------- state, link token, storage ---------- */
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function encHeads(list) { return list.map(function (h) { return h.o + (h.c.length ? "c" + h.c.join(".") : ""); }).join("-"); }
  function decHeads(s) {
    return s.split("-").map(function (p) {
      var m = /^(\d+)(?:c([\d.]+))?$/.exec(p); if (!m) throw 0;
      var o = Math.min(48, Math.max(1, +m[1]));
      var c = m[2] ? m[2].split(".").map(Number).filter(function (i) { return i < o; }) : [];
      return { o: o, c: c };
    });
  }
  function token(s) {
    var side = function (list, g) { return list.length ? encHeads(list) : "g" + g; };
    return ["m" + MACHINES.indexOf(s.machine), "p" + PRODUCTS.indexOf(s.product), "s" + side(s.seed, s.seedG), "f" + side(s.fert, s.fertG),
      "t" + (s.seedTube === "unknown" ? "u" : s.seedTube), "u" + (s.fertTube === "same" ? "s" : s.fertTube === "unknown" ? "u" : s.fertTube),
      "d" + s.display, "w" + String(s.width).replace(/[^\d]/g, "~"), "r" + String(s.spacing).replace(/[^\d]/g, "~")]
      // extra sensors only when there are any: shafts.shaft.hoppers.perHopper.fans.speed
      .concat(s.shafts || s.hop || s.turb || s.speed !== "auto" ?
        ["x" + [s.shafts, SHAFTS.indexOf(s.shaft), s.hop, s.hopN, s.turb, SPEEDS.indexOf(s.speed)].join(".")] : []).join("_");
  }
  function untoken(t) {
    var f = {}; t.split("_").forEach(function (x) { f[x[0]] = x.slice(1); });
    var tube = function (v) { return v === "u" ? "unknown" : [25, 30, 32, 35, 50].indexOf(+v) >= 0 ? +v : null; };
    var s = {
      machine: MACHINES[+f.m], product: PRODUCTS[+f.p],
      seed: f.s[0] === "g" ? [] : decHeads(f.s), fert: f.f[0] === "g" ? [] : decHeads(f.f),
      seedG: f.s[0] === "g" ? Math.min(150, Math.max(1, +f.s.slice(1) || 24)) : 24,
      fertG: f.f[0] === "g" ? Math.min(150, Math.max(1, +f.f.slice(1) || 24)) : 24,
      seedTube: tube(f.t), fertTube: f.u === "s" ? "same" : tube(f.u), display: f.d,
      width: (f.w || "").replace(/~/g, ","), spacing: (f.r || "").replace(/~/g, ",")
    };
    var x = (f.x || "").split(".").map(Number), lim = function (v, a, b) { return isFinite(v) ? Math.max(a, Math.min(b, v)) : a; };
    s.shafts = lim(x[0], 0, 6); s.shaft = SHAFTS[lim(x[1], 0, 2)]; s.hop = lim(x[2], 0, 3); s.hopN = lim(x[3], 1, 2);
    s.turb = lim(x[4], 0, 2); s.speed = SPEEDS[lim(x[5], 0, 4)];
    if (!s.machine || !s.product || s.seedTube === null || s.fertTube === null || DISPLAYS.indexOf(s.display) < 0) throw 0;
    return s;
  }
  function save() { try { localStorage.setItem("aw-wizard", token(st)); localStorage.setItem("aw-wizard-lang", ui.lang); } catch (e) {} }
  function load() {
    var h = (location.hash || "").slice(1);
    try { if (h) return untoken(h); } catch (e) {}
    try { var t = localStorage.getItem("aw-wizard"); if (t) return untoken(t); } catch (e) {}
    return clone(DEFAULT);
  }

  /* ---------- composition ---------- */
  function cfgOf(s) {
    // A gravity drill goes to the rules as one head holding all its rows: sensors chain, no cables between heads.
    var toHeads = function (l, g) { return l.length ? l.map(function (h) { return { outlets: h.o, closed: h.c.slice() }; }) : [{ outlets: g, closed: [] }]; };
    return { machine: s.machine, seedHeads: toHeads(s.seed, s.seedG), seedTube: s.seedTube, seedGravity: !s.seed.length,
      fert: { seedOnly: "none", separate: "separate", shared: "shared" }[s.product],
      fertHeads: toHeads(s.fert, s.fertG), fertGravity: !s.fert.length, fertTube: s.fertTube, display: s.display,
      // the arm of the figure-eight is half the width + 1 m: rows x spacing first, the farmer's width otherwise
      width: (function () { var sp = parseNum(s.spacing), rows = R.sumRows(toHeads(s.seed, s.seedG)); return sp ? (rows * sp) / 100 : parseNum(s.width); })(),
      aux: auxOf(s) };
  }
  // The 3-pin layer (sensor-layer.js): the farmer names sensors, never the hub; speed comes by itself when needed (owner 31.10).
  function auxOf(s) {
    if (!s.shafts && !s.hop && !s.turb) return undefined;
    var hoppers = []; for (var i = 0; i < s.hop; i++) hoppers.push(s.hopN);
    var aux = { shafts: s.shafts, shaft: s.shaft, hoppers: hoppers, turbines: s.turb };
    aux.speed = SL.speedNeeded(aux) ? s.speed : "auto";
    return aux;
  }
  // Unknown hose: priced as the cheapest sensor and marked "about".
  function pricedOf(s) {
    var c = cfgOf(s);
    if (c.seedTube === "unknown") c.seedTube = 25;
    if (c.fertTube === "unknown") c.fertTube = 25;
    return c;
  }
  function priceOf(s) { return R.price(R.compose(pricedOf(s)).bom, PRICES); }
  function money(v) {
    try { return new Intl.NumberFormat(ui.lang, { style: "currency", currency: CURRENCY, minimumFractionDigits: 0, maximumFractionDigits: v % 1 ? 2 : 0 }).format(v); }
    catch (e) { return Math.round(v) + " €"; }
  }
  function delta(alt) {
    var d = priceOf(alt) - priceOf(st);
    if (!d) return "";
    return '<span class="c-d' + (d < 0 ? " neg" : "") + '">' + (d > 0 ? "+" : "−") + money(Math.abs(d)) + "</span>";
  }
  function tr(k, v) { var s = (TEXT[ui.lang] || TEXT.en)[k]; if (s == null) s = TEXT.en[k] || k; for (var x in v || {}) s = s.split("{" + x + "}").join(v[x]); return s; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function partName(sku) {
    var tube = null;
    Object.keys(R.TUBE_SENSOR).forEach(function (d) { if (R.TUBE_SENSOR[d] === sku) tube = d; });
    if (tube) return tr("n_sensor", { d: tube });
    var len = { "AC05.02.01.01.000": 2, "AC05.02.01.02.000": 4, "AC05.02.01.03.000": 6, "AC05.02.01.04.000": 8, "AC05.02.01.08.000": 11 }[sku];
    if (len) return tr("n_comm", { l: len });
    if (sku.charAt(0) === "?") return tr("n_" + sku.slice(1));   // no shop product yet (blind plugs)
    for (var e in SL.EXT_SKU) if (SL.EXT_SKU[e] === sku) return tr("n_ext", { l: e });
    for (var w in SL.STAR) if (SL.STAR[w] === sku) return tr("n_star", { d: tr("x_" + w) });
    var aux = { "AC02.02.08.05.000": "n_hub8", "AC05.03.08.08.000": "n_hubNet", "AC05.03.08.09.000": "n_harness4", "AC03.02.02.01.000": "n_ind18",
      "AC06.01.01.01.000": "n_angle18", "AC03.03.02.01.000": "n_hopperS", "AC02.05.01.00": "n_turbine", "AC05.02.04.20.000": "n_iso" }[sku];
    if (aux) return tr(aux);
    return tr({ "AC08.02.01.05.010": "n_splitter", "AC08.02.01.06.000": "n_termEsd", "AC08.02.01.03": "n_termCan",
      "AC05.03.03.08.001": "n_power", "AC01.01.03.02.000": "n_mini", "AC01.01.04.03.000": "n_h5", "AC01.01.04.04.100": "n_one" }[sku]);
  }

  function parseNum(v) { var n = parseFloat(String(v).replace(",", ".")); return isFinite(n) && n > 0 ? n : null; }
  function rowsOf(kind) { var list = st[kind]; return list.length ? list.reduce(function (a, h) { return a + h.o - h.c.length; }, 0) : st[kind + "G"]; }
  function gravity(kind) { return !st[kind].length; }
  function headsText(kind) {
    return gravity(kind) ? tr("h_gravityShort") + " · " + rowsOf(kind) : st[kind].map(function (h) { return h.o - h.c.length; }).join("+") + " = " + rowsOf(kind);
  }

  /* ---------- rendering ---------- */
  function steps() {
    var l = ["machine", "product", "heads"];
    if (st.product === "separate") l.push("fert");
    l.push("tube", "display", "sensors", "summary");
    return l;
  }
  function stepTitle(k) { return tr({ machine: "st_machine", product: "st_product", heads: "st_heads", fert: "st_fert", tube: "st_tube", display: "st_display", sensors: "st_sensors", summary: "st_summary" }[k]); }
  function stepValue(k, res, total) {
    switch (k) {
      case "machine": return tr("m_" + st.machine);
      case "product": return tr("p_" + st.product);
      case "heads": return tr("h_rows") + ": " + rowsOf("seed") + " · " + st.seed.length + "×";
      case "fert": return tr("h_rows") + ": " + rowsOf("fert") + " · " + st.fert.length + "×";
      case "tube": return (st.seedTube === "unknown" ? "Ø ?" : "Ø" + st.seedTube) +
        (st.product === "separate" ? " / " + (st.fertTube === "same" ? (st.seedTube === "unknown" ? "Ø ?" : "Ø" + st.seedTube) : st.fertTube === "unknown" ? "Ø ?" : "Ø" + st.fertTube) : "");
      case "display": return tr("d_" + st.display);
      case "sensors": var n = st.shafts + st.hop * st.hopN + st.turb; return n ? tr("x_count", { n: n }) : tr("x_none");
      case "summary": return (res.quote.length ? "≈ " : "") + money(total);
    }
  }

  function card(attrs, inner) { return '<button type="button" class="card" ' + attrs + ">" + inner + "</button>"; }

  function bodyMachine() {
    return '<div class="cards">' + MACHINES.map(function (m) {
      var alt = clone(st); alt.machine = m;
      return card('data-set="machine" data-val="' + m + '" aria-pressed="' + (st.machine === m) + '"',
        D.silhouette(m, gravity("seed")) + '<span class="c-t">' + esc(tr("m_" + m)) + "</span>" + (st.machine === m ? "" : delta(alt)));
    }).join("") + "</div>";
  }
  function hosePict(kind) {
    var g = '<svg viewBox="0 0 120 50" aria-hidden="true">';
    if (kind === "seedOnly") g += '<path d="M10 25 H110" stroke="var(--seed)" stroke-width="10" stroke-linecap="round"/>';
    if (kind === "separate") g += '<path d="M10 16 H110" stroke="var(--seed)" stroke-width="9" stroke-linecap="round"/><path d="M10 36 H110" stroke="var(--fert)" stroke-width="9" stroke-linecap="round"/>';
    if (kind === "shared") g += '<path d="M10 25 H110" stroke="var(--sil)" stroke-width="16" stroke-linecap="round"/><path d="M14 25 H106" stroke="var(--seed)" stroke-width="4" stroke-dasharray="8 8"/><path d="M22 25 H106" stroke="var(--fert)" stroke-width="4" stroke-dasharray="8 8"/>';
    return g + "</svg>";
  }
  function bodyProduct() {
    return '<div class="cards three">' + PRODUCTS.map(function (p) {
      var alt = clone(st); alt.product = p;
      return card('data-set="product" data-val="' + p + '" aria-pressed="' + (st.product === p) + '"',
        hosePict(p) + '<span class="c-t">' + esc(tr("p_" + p)) + "</span>" + (st.product === p ? "" : delta(alt)));
    }).join("") + "</div>" + (st.product === "shared" ? '<p class="hint">' + esc(tr("p_sharedNote")) + "</p>" : "");
  }
  function stepper(id, label, val, min, max) {
    return '<div class="stepper"><label id="' + id + '-l">' + esc(label) + '</label><div class="ctl" role="group" aria-labelledby="' + id + '-l">' +
      '<button type="button" id="' + id + '-dn" data-step="' + id + '" data-d="-1" aria-label="−"' + (typeof val === "number" && val <= min ? " disabled" : "") + ">−</button>" +
      '<output id="' + id + '-v">' + esc(val) + "</output>" +
      '<button type="button" id="' + id + '-up" data-step="' + id + '" data-d="1" aria-label="+"' + (typeof val === "number" && val >= max ? " disabled" : "") + ">+</button></div></div>";
  }
  function minHeads() { return st.machine === "mounted" || st.machine === "trailed" ? 0 : 1; }
  function bodyHeads(kind) {
    var list = st[kind];
    if (!list.length) {
      var g = '<div class="rowsum"><span class="big">' + st[kind + "G"] + '</span><span class="of">' + esc(tr("h_rows")) + " · " + esc(tr("h_gravityShort")) + "</span></div>";
      g += '<p class="hint">' + esc(tr("h_gravity")) + "</p>";
      g += stepper(kind + "-n", tr("h_heads"), 0, minHeads(), 16);
      g += stepper(kind + "-rows", tr("h_rows"), st[kind + "G"], 1, 150);
      return g + (kind === "seed" ? widthCheck(st[kind + "G"]) : "");
    }
    var sel = Math.min(ui.sel[kind], list.length - 1); ui.sel[kind] = sel;
    var same = list.every(function (h) { return h.o === list[0].o; });
    var rows = rowsOf(kind);
    var h = '<div class="rowsum"><span class="big">' + rows + '</span><span class="of">' + esc(tr("h_rows")) + " = " +
      list.map(function (x) { return x.o - x.c.length; }).join(" + ") + "</span></div>";
    h += '<p class="hint">' + esc(tr("h_hint")) + "</p>";
    h += stepper(kind + "-n", tr("h_heads"), list.length, minHeads(), 16);
    h += stepper(kind + "-each", tr("h_each"), same ? list[0].o : tr("h_mixed"), 1, 48);
    h += '<div class="picker' + (kind === "fert" ? " fert" : "") + '" role="group" aria-label="' + esc(tr("h_heads")) + '">' + list.map(function (x, i) {
      return '<button type="button" data-pick="' + kind + '" data-i="' + i + '" aria-pressed="' + (i === sel) + '">' +
        '<svg viewBox="0 0 40 40" aria-hidden="true">' + D.head(20, 20, 17, x.o, x.c, "") + "</svg>" + (i + 1) + " · " + (x.o - x.c.length) + "</button>";
    }).join("") + "</div>";
    var hd = list[sel];
    h += '<div class="editor">' + stepper(kind + "-one", tr("h_head") + " " + (sel + 1) + " · " + tr("h_outlets"), hd.o, 1, 48) +
      D.headEditor(hd, kind, tr("h_head") + " " + (sel + 1)) +
      '<p class="hint">' + esc(tr("h_tap")) + (hd.c.length ? " " + esc(tr("h_closed")) + ": " + hd.c.length + "." : "") + "</p></div>";
    if (kind === "seed") h += widthCheck(rows);
    return h;
  }
  /* Width and spacing only check the hoses the farmer counted; the kit always comes from the hoses.
     Working width of a drill = rows × row spacing. A farmer often says "11 m" for 11,25 m, so 5 % off in the
     spacing still matches; one value given, the other one is worked out. Spacing snaps to the usual values. */
  var SPACINGS = [10, 12, 12.5, 13, 14, 15, 16, 16.7, 17, 17.5, 18, 18.75, 19, 20, 21, 22, 22.5, 25, 30, 33.3, 35, 37.5, 45, 50, 70, 75, 76.2, 80];
  function snapSpacing(cm) {
    var best = null;
    SPACINGS.forEach(function (v) { if (Math.abs(v - cm) / v <= 0.02 && (best === null || Math.abs(v - cm) < Math.abs(best - cm))) best = v; });
    return best !== null ? best : Math.round(cm * 10) / 10;
  }
  function num(v, d) {
    try { return new Intl.NumberFormat(ui.lang, { minimumFractionDigits: 0, maximumFractionDigits: d }).format(v); } catch (e) { return String(v); }
  }
  function exactWidth(rows) { var sp = parseNum(st.spacing); return sp ? (rows * sp) / 100 : parseNum(st.width); }
  function widthCheck(rows) {
    var w = parseNum(st.width), sp = parseNum(st.spacing), msg = "";
    if (rows && w && sp) {
      var exact = (rows * sp) / 100, implied = (w * 100) / rows;
      if (Math.abs(implied - sp) / sp <= 0.05) {
        msg = '<span class="ok">' + esc(tr("chk_ok", { rows: rows, s: num(sp, 2), w: num(exact, 2) })) + "</span>" +
          (Math.abs(exact - w) >= 0.01 ? " " + esc(tr("chk_rounded", { W: num(w, 2), w: num(exact, 2) })) : "");
      } else {
        msg = '<span class="bad">' + esc(tr("chk_off", { rows: rows, s: num(sp, 2), w: num(exact, 2), W: num(w, 2), si: num(snapSpacing(implied), 2) })) + "</span>";
      }
    } else if (rows && sp) {
      msg = esc(tr("chk_calcWidth", { rows: rows, s: num(sp, 2), w: num((rows * sp) / 100, 2) }));
    } else if (rows && w) {
      msg = esc(tr("chk_calcSpacing", { rows: rows, W: num(w, 2), s: num(snapSpacing((w * 100) / rows), 2) }));
    }
    return '<div class="check"><h4>' + esc(tr("chk_title")) + "</h4>" +
      '<label>' + esc(tr("chk_width")) + '<input id="in-width" inputmode="decimal" autocomplete="off" value="' + esc(st.width) + '"></label>' +
      '<label>' + esc(tr("chk_spacing")) + '<input id="in-spacing" inputmode="decimal" autocomplete="off" value="' + esc(st.spacing) + '"></label>' +
      (msg ? "<p>" + msg + "</p>" : "") + "</div>";
  }
  function tubeCards(field, withSame) {
    var opts = (withSame ? ["same"] : []).concat(TUBES);
    return '<div class="cards tubes">' + opts.map(function (t) {
      var alt = clone(st); alt[field] = t;
      var pict = t === "same" ? '<div class="tube"><span style="width:44px;height:44px;border-style:dashed"></span></div>'
        : t === "unknown" ? '<div class="tube" style="font:600 30px var(--mono);color:var(--faint)">?</div>'
        : '<div class="tube"><span style="width:' + (14 + t * 1.1) + "px;height:" + (14 + t * 1.1) + 'px"></span></div>';
      var label = t === "same" ? tr("t_same") : t === "unknown" ? tr("t_unknown") : "Ø" + t + " mm";
      return card('data-set="' + field + '" data-val="' + t + '" aria-pressed="' + (st[field] === t) + '"',
        pict + '<span class="c-t">' + esc(label) + "</span>" + (st[field] === t ? "" : delta(alt)));
    }).join("") + "</div>";
  }
  function bodyTube() {
    var h = '<p class="hint">' + esc(tr("t_hint")) + "</p>" + '<p class="hint">' + esc(tr("t_pro")) + "</p>";
    if (st.product === "separate") h += "<strong>" + esc(tr("t_seed")) + "</strong>";
    h += tubeCards("seedTube", false);
    if (st.product === "separate") h += "<strong>" + esc(tr("t_fert")) + "</strong>" + tubeCards("fertTube", true);
    return h;
  }
  function displayPict(d) {
    var w = { mini: 46, h5: 66, one: 92 }[d], h = { mini: 40, h5: 46, one: 56 }[d];
    return '<svg viewBox="0 0 120 64" aria-hidden="true"><rect x="' + (60 - w / 2) + '" y="' + (32 - h / 2) + '" width="' + w + '" height="' + h + '" rx="4" fill="#262726" stroke="var(--sil)" stroke-width="2.5"/>' +
      '<rect x="' + (60 - w / 2 + 6) + '" y="' + (32 - h / 2 + 6) + '" width="' + (w - 12) + '" height="' + (h - 16) + '" fill="var(--accent)" opacity=".55"/></svg>';
  }
  function bodyDisplay(res) {
    return '<div class="cards three">' + DISPLAYS.map(function (d) {
      var alt = clone(st); alt.display = d;
      var off = d === "mini" && res.total > R.MINI_MAX_ROWS;
      return card('data-set="display" data-val="' + d + '" aria-pressed="' + (st.display === d) + '"' + (off ? ' aria-disabled="true"' : ""),
        displayPict(d) + '<span class="c-t">' + esc(tr("d_" + d)) + "</span>" +
        (d === "mini" ? '<span class="c-s">' + esc(tr("d_miniOff")) + "</span>" : "") +
        '<span class="c-s">' + money(PRICES[R.DISPLAY[d]]) + "</span>" + (st.display === d ? "" : delta(alt)));
    }).join("") + "</div>";
  }
  /* Extra sensors (owner 29-31.10): shafts, hoppers, fans; the hub, harnesses, plugs and extensions follow by themselves.
     Speed shows only when something needs it, with the monitor's own source first. */
  function auxCard(field, val, label) {
    var alt = clone(st); alt[field] = val;
    return card('data-set="' + field + '" data-val="' + val + '" aria-pressed="' + (st[field] === val) + '"',
      '<span class="c-t">' + esc(label) + "</span>" + (st[field] === val ? "" : delta(alt)));
  }
  function shaftSign(w) {
    // a square or a hexagon; the 25.5 mm hexagon drawn a little larger than the 22.5 mm one
    var r = { hex22: 8, hex25: 10, sq17: 8 }[w], pts = [];
    if (w === "sq17") return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="5" width="14" height="14" rx="1.5"/></svg>';
    for (var i = 0; i < 6; i++) pts.push((12 + r * Math.cos(Math.PI / 3 * i)).toFixed(1) + "," + (12 + r * Math.sin(Math.PI / 3 * i)).toFixed(1));
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="' + pts.join(" ") + '"/></svg>';
  }
  function bodySensors(res) {
    // each kind of sensor is its own group under a thin line, the speed line too (owner 31.10)
    var h = '<p class="hint">' + esc(tr("x_hint")) + "</p>";
    // the (i) of the shaft sensor: what it shows, and the rate in kg/ha after a calibration (owner 31.10)
    var info = '<button type="button" class="info" data-act="info" aria-expanded="' + !!ui.shaftInfo + '" aria-label="i">i</button>';
    // the (i) is glued to the label's last word, so it wraps with it and never drifts to the counter (owner 31.10)
    var lab = tr("x_shafts"), cut = lab.lastIndexOf(" ");
    h += '<div class="xgrp">' + stepper("aux-shafts", lab, st.shafts, 0, 6).replace(">" + esc(lab) + "</label>",
      ">" + esc(lab.slice(0, cut + 1)) + '<span class="nw">' + esc(lab.slice(cut + 1)) + info + "</span></label>") +
      (ui.shaftInfo ? '<p class="hint">' + esc(tr("x_shaftInfo")) + "</p>" : "");
    // shaft type (owner 31.10): three small signs next to the count, not three big buttons; the split star wheel is the shaft's
    if (st.shafts) h += '<div class="shaftpick" role="group" aria-label="' + esc(tr("x_shaftType")) + '">' + SHAFTS.map(function (w) {
        return '<button type="button" data-set="shaft" data-val="' + w + '" aria-pressed="' + (st.shaft === w) + '" title="' + esc(tr("x_" + w)) + '" aria-label="' + esc(tr("x_" + w)) + '">' + shaftSign(w) + "</button>";
      }).join("") + '<span class="sp-name">' + esc(tr("x_" + st.shaft)) + "</span></div>" +
      '<p class="hint">' + esc(tr("x_shaftHint")) + "</p>";
    h += "</div>";
    h += '<div class="xgrp">' + stepper("aux-hop", tr("x_hoppers"), st.hop, 0, 3);
    if (st.hop) h += '<div class="cards chips">' + auxCard("hopN", 1, tr("x_per1")) + auxCard("hopN", 2, tr("x_per2")) + "</div>";
    h += "</div>";
    h += '<div class="xgrp">' + stepper("aux-turb", tr("x_turbines"), st.turb, 0, 2) + "</div>";
    var sens = res.sensors;
    if (sens && SL.speedNeeded(cfgOf(st).aux)) {
      var opts = (SL.GPS[st.display] ? ["gps"] : []).concat(["iso", "drill", "cart"]);
      var cur = sens.speed;
      h += '<div class="xgrp"><p><strong>' + esc(tr("x_speed")) + ":</strong> " + esc(tr("x_sp_" + cur)) +
        (ui.speedOpen ? "" : ' · <button type="button" class="linkbtn" data-act="speed">' + esc(tr("x_change")) + "</button>") + "</p>" +
        '<p class="hint">' + esc(tr("x_speedWhy")) + (cur === "iso" ? " " + esc(tr("x_isoCheck")) : "") + "</p>";
      if (ui.speedOpen) h += '<div class="cards chips">' + opts.map(function (o) {
        var alt = clone(st); alt.speed = o;
        return card('data-set="speed" data-val="' + o + '" aria-pressed="' + (cur === o) + '"', '<span class="c-t">' + esc(tr("x_sp_" + o)) + "</span>" + (cur === o ? "" : delta(alt)));
      }).join("") + "</div>";
      h += "</div>";
    }
    return h;
  }

  /* The extra sensors in the parts list (owner 31.10, B): one group "connected to A2"; the hub with its harnesses and plugs,
     then each kind of sensor with its sign and, indented under it, what comes with it (extension, bracket, star wheel).
     A line lights its part of the drawing: the hub box, or that sensor's leads (k-… tokens in draw.js). */
  function layerRows(sens, des) {
    if (!sens || !sens.parts.length) return "";
    var line = function (q, sub, hlKey, extra) {
      // a sensor is named by what it does ("Ground speed sensor", "Shaft rotation sensor"), its article below says which part it is
      var sku = q.sku || "?" + q.key, name = q.role === "sensor" ? tr("port_" + q.why) : partName(sku);
      var tag = des && des[sku] ? '<b class="des">' + esc(des[sku]) + "</b> · " : "";
      return '<tr tabindex="0" class="' + (sub ? "sub" : "lead") + '" data-hl="' + hlKey + '"><td class="q">' + q.qty + ' ×</td><td class="n">' +
        (sub ? "" : D.kindIcon(q.why === "hub" ? "hub" : q.why)) + esc(name) + (extra || "") + "<small>" + tag + (q.sku ? esc(q.sku) : "—") + "</small></td>" +
        '<td class="p">' + (q.sku ? money(PRICES[q.sku] * q.qty) : "—") + "</td></tr>";
    };
    var on = sens.hubs ? Array.apply(null, Array(sens.hubs)).map(function (x, i) { return "A" + (i + 2); }).join(", ") : "A1";
    var h = '<tr class="grp"><td colspan="3">' + esc(tr("s_auxHead", { a: on })) + "</td></tr>";
    var hub = sens.parts.filter(function (q) { return q.why === "hub"; });
    hub.forEach(function (q) {
      var btn = q.role === "hub8" ? ' <button type="button" class="linkbtn ports" data-act="hub">' + esc(tr("hub_btn")) + "</button>" : "";
      h += line(q, q.role !== "hub8", "k-hub", btn);
    });
    ["speed", "shaft", "turbine", "hopper"].forEach(function (kind) {
      var mine = sens.parts.filter(function (q) { return q.why === kind; });
      var head = mine.filter(function (q) { return q.role === "sensor" || q.role === "iso"; });
      head.forEach(function (q) { h += line(q, false, "k-" + kind); });
      mine.filter(function (q) { return head.indexOf(q) < 0; }).forEach(function (q) { h += line(q, true, "k-" + kind); });
    });
    return h;
  }
  function bodySummary(res, spare, des) {
    var priced = R.compose(pricedOf(st));
    var unknownSensors = {};
    if (st.seedTube === "unknown") unknownSensors[R.TUBE_SENSOR[25]] = true;
    if (st.product === "separate" && (st.fertTube === "unknown" || (st.fertTube === "same" && st.seedTube === "unknown"))) unknownSensors[R.TUBE_SENSOR[25]] = true;
    // the 3-pin layer's parts go in a group of their own below (owner 31.10, B); the main list keeps the bus
    var sens = priced.sensors, layerSku = {};
    if (sens) sens.parts.forEach(function (q) { layerSku[q.sku || "?" + q.key] = true; });
    var rows = priced.bom.filter(function (l) { return !layerSku[l.sku]; }).map(function (l) {
      var name = partName(l.sku), sku = l.sku.charAt(0) === "?" ? "—" : l.sku;
      if (unknownSensors[l.sku]) { name = tr("n_sensor", { d: "?" }); sku = "AC03.01.0?"; }
      // the designations of the drawing ("W2, W4–W6") before the article: hover the line, the drawing lights them (owner 29.10)
      var tag = des && des[l.sku] ? '<b class="des">' + esc(des[l.sku]) + "</b> · " : "";
      return '<tr tabindex="0" data-hl="' + l.sku + '"><td class="q">' + l.qty + " ×</td><td class=\"n\">" + esc(name) + "<small>" + tag + esc(sku) + "</small></td>" +
        '<td class="p">' + (unknownSensors[l.sku] ? "≈ " : "") + money(PRICES[l.sku] * l.qty) + "</td></tr>";
    }).join("") + layerRows(sens, des);
    var total = R.price(priced.bom, PRICES);
    var h = '<p class="note hlhint">' + esc(tr("s_hlHint")) + "</p>" + '<table class="bom"><caption hidden>' + esc(tr("s_contents")) + "</caption><tbody>" + rows + "</tbody>" +
      '<tfoot><tr><td></td><td>' + esc(tr("s_total")) + '</td><td class="p">' + (res.quote.length ? "≈ " : "") + money(total) + "</td></tr></tfoot></table>";
    h += '<p class="note">' + esc(tr("s_prices")) + (spare > 0 ? " " + esc(tr("s_spare")) : "") +
      (priced.bom.some(function (l) { return l.sku.charAt(0) === "?"; }) ? " " + esc(tr("s_plugNote")) : "") + "</p>";
    var check = checks(res), canCart = res.quote.indexOf("unavailable") < 0;
    if (res.quote.length) h += '<div class="reasons"><h4>' + esc(tr("q_title")) + "</h4><ul>" + res.quote.map(function (q) { return "<li>" + esc(tr("q_" + q)) + "</li>"; }).join("") + "</ul>" +
      (canCart ? '<p class="note">' + esc(tr("q_howto")) + "</p>" : "") + "</div>";
    h += '<div class="actions">' + (canCart ? cartButton(check) : "") +
      '<a class="btn' + (canCart ? "" : " primary") + '" data-act="quote" target="_blank" rel="noopener" href="' + esc(waHref(quoteText())) + '">' + WA_SVG.replace("<svg", '<svg width="18" height="18"') + esc(tr(canCart ? "b_askWa" : "b_quote")) + "</a></div>" +
      '<p class="note">' + esc(tr("wa_number")) + ": " + WA_SHOWN + " · " + MAIL + "</p>";
    h += '<button type="button" class="linkbtn" data-act="share">' + esc(tr("b_share")) + "</button>";
    return h;
  }

  /* Quote = a Shopify order paid by invoice (owner 22.10): whatever the engineer has to confirm still goes to the cart,
     each line carries what to check; the owner edits the order and sends the invoice. Only a part missing from the
     shop keeps the cart closed. */
  function checks(res) { return res.quote.filter(function (q) { return q !== "unavailable"; }); }
  function cartButton(check, cls) {
    return '<button type="button" class="btn primary' + (cls || "") + '" data-act="cart">' + esc(tr(check.length ? "b_request" : "b_cart")) + "</button>";
  }

  function render() {
    var keep = document.activeElement && document.activeElement.id, caret = keep && document.activeElement.selectionStart;
    var L = TEXT[ui.lang] || TEXT.en;
    document.documentElement.lang = ui.lang;
    ["title", "lead", "mock"].forEach(function (k) { var el = document.getElementById("t-" + k); if (el) el.textContent = L[k]; });

    var cfg = cfgOf(st), res = R.compose(cfg), total = priceOf(st);
    // a part missing from the shop (unpublished, sold out) can't go to the cart: the engineer confirms it
    // blind plugs ("?…") have no shop product yet: they go in the box, not in the cart
    if (SITE && R.compose(pricedOf(st)).bom.some(function (l) { return l.sku.charAt(0) !== "?" && !VARIANT[l.sku]; })) res.quote.push("unavailable");
    var seedSensor = R.TUBE_SENSOR[cfg.seedTube] || "";
    var fertTube = cfg.fertTube === "same" ? cfg.seedTube : cfg.fertTube;
    var w = parseNum(st.width);
    var p = D.plan(cfg, res, {
      L: L, sku: { comm4: R.SKU.comm4, comm8: R.SKU.comm8, splitter: R.SKU.splitter, power: R.SKU.power, display: R.DISPLAY[st.display],
        term_esd: R.SKU.term_esd, term_can: R.SKU.term_can, comm2: R.SKU.comm2, comm6: R.SKU.comm6, comm11: R.SKU.comm11, hub8: SL.SKU.hub8,
        // the display lights for the tractor cable and for a speed sensor plugged straight into it
        iso: res.sensors && (res.sensors.speed === "iso" || (res.sensors.speed === "drill" && !res.sensors.speedOnHub)) ? "k-speed" : "" },
      seedSensor: seedSensor, fertSensor: R.TUBE_SENSOR[fertTube] || "",
      dimLabel: (exactWidth(res.seedRows) ? num(exactWidth(res.seedRows), 2) + " m · " : "") + L.h_rows + ": " + res.seedRows,
      aria: L.st_summary
    });
    var plan = document.getElementById("plan");
    plan.innerHTML = p.svg;
    plan.dataset.focus = ui.open;
    document.getElementById("sil").innerHTML = D.silhouette(st.machine, gravity("seed"));
    document.getElementById("stage-foot").innerHTML =
      "<span>" + esc(L.sum_rows) + ": <b>" + res.seedRows + (res.fertRows ? " + " + res.fertRows : "") + "</b></span>" +
      "<span>" + esc(L.sum_sensors) + ": <b>" + (res.total) + "</b></span>" +
      "<span>" + esc(L.s_total) + ": <b>" + (res.quote.length ? "≈ " : "") + money(total) + "</b></span>";

    var list = steps();
    if (list.indexOf(ui.open) < 0) ui.open = "heads";
    document.getElementById("steps").innerHTML = list.map(function (k, i) {
      var open = ui.open === k, body = "";
      if (open) {
        body = k === "machine" ? bodyMachine() : k === "product" ? bodyProduct() : k === "heads" ? bodyHeads("seed") : k === "fert" ? bodyHeads("fert")
          : k === "tube" ? bodyTube() : k === "display" ? bodyDisplay(res) : k === "sensors" ? bodySensors(res) : bodySummary(res, p.spare, p.des);
        if (k !== "summary") body += '<a class="ask" data-act="ask" data-stepk="' + k + '" target="_blank" rel="noopener" href="' + esc(waHref(askText(k))) + '">' + WA_SVG + esc(L.b_ask) + "</a>" +
          '<button type="button" class="next" data-act="next">' + esc(L.b_next) + " →</button>";
      }
      return '<li class="step' + (open ? " open" : "") + '"><button type="button" class="step-head" id="sh-' + k + '" aria-expanded="' + open + '" aria-controls="sb-' + k + '" data-open="' + k + '">' +
        '<span class="step-n">' + (i + 1) + '</span><span class="step-t">' + esc(stepTitle(k)) + '</span><span class="step-v">' + esc(stepValue(k, res, total)) + '</span><span class="chev" aria-hidden="true"></span></button>' +
        (open ? '<div class="step-body" id="sb-' + k + '">' + body + "</div>" : "") + "</li>";
    }).join("");

    var needQuote = res.quote.indexOf("unavailable") >= 0;
    document.getElementById("bar").innerHTML = '<div class="sum"><small>' + esc(L.s_total) + " · " + esc(L.sum_rows) + " " + res.seedRows +
      (res.fertRows ? " + " + res.fertRows : "") + "</small><b>" + (res.quote.length ? "≈ " : "") + money(total) + "</b></div>" +
      (needQuote ? '<a class="btn primary" data-act="quote" target="_blank" rel="noopener" href="' + esc(waHref(quoteText())) + '">' + esc(L.b_quote) + "</a>"
        : cartButton(checks(res)));

    // the "does it fit" line (section, owner 30.10) stays under the result while the summary is open; its state survives re-renders
    var fit = document.getElementById("site-question-wizard-fit");
    if (fit) fit.hidden = ui.open !== "summary";

    if (keep) { var el = document.getElementById(keep); if (el) { el.focus(); if (caret != null && el.setSelectionRange) try { el.setSelectionRange(caret, caret); } catch (e) {} } }
    save();
  }

  // HUB-8 close up: which sensor on which port; a tap on the hub on the drawing or on "Ports" in the parts list
  function showHub() {
    var sens = R.compose(cfgOf(st)).sensors;
    if (!sens || !sens.hubs) return;
    track("change", { field: "hub_ports", value: sens.ports.length });
    sheet(tr("hub_title"), tr("hub_note"), null, D.hubDetail(sens, TEXT[ui.lang] || TEXT.en));
  }
  document.addEventListener("click", function (e) {
    var g = e.target.closest && e.target.closest("#plan .hub8");
    if (g) showHub();
  });

  /* ---------- does this setup fit your drill (owner 30-31.10) ---------- */
  // The shared site-question element sends wizard_fit itself; here the configuration link goes into the message's
  // Configuration field, so the mail says which kit it is about.
  document.addEventListener("site-question:answer", function (e) {
    var box = e.target;
    if (!box || box.id !== "site-question-wizard-fit") return;
    EVENTS.push({ name: "wizard_fit", data: { answer: e.detail && e.detail.answer } });
    var f = box.querySelector("form");
    if (f && f.elements["contact[Configuration]"]) f.elements["contact[Configuration]"].value = PAGE_URL + "#" + token(st);
  });

  /* ---------- messages to us ---------- */
  function summaryText() {
    var cfg = cfgOf(st), res = R.compose(cfg);
    var lines = [tr("msg_drill") + ": " + tr("m_" + st.machine) + ", " + tr("p_" + st.product).toLowerCase(),
      tr("st_heads") + ": " + headsText("seed")];
    if (st.product === "separate") lines.push(tr("st_fert") + ": " + headsText("fert"));
    lines.push(tr("st_tube") + ": " + stepValue("tube"), tr("st_display") + ": " + tr("d_" + st.display));
    if (parseNum(st.width)) lines.push(tr("chk_width") + ": " + st.width + "; " + tr("chk_spacing") + ": " + st.spacing);
    lines.push(tr("msg_link") + ": " + PAGE_URL + "#" + token(st));
    return lines.join("\n");
  }
  function sheet(title, note, text, extra) {
    var s = document.getElementById("sheet");
    s.innerHTML = '<h3 id="modal-h">' + esc(title) + '</h3><p class="note">' + esc(note) + "</p>" + (text != null ? "<pre id=\"msg\">" + esc(text) + "</pre>" : "") + (extra || "") +
      '<div class="actions">' + (text != null ? '<button type="button" class="btn primary" data-act="copy">' + esc(tr("b_copy")) + "</button>" : "") +
      '<button type="button" class="btn" data-act="close">' + esc(tr("b_close")) + "</button></div>";
    document.getElementById("modal").hidden = false;
    var b = s.querySelector(".btn"); if (b) b.focus();
  }
  // One tap: WhatsApp opens with the message and the configuration link already typed in.
  function waHref(text) { return "https://wa.me/" + WA + "?text=" + encodeURIComponent(text); }
  function mailHref(text) { return "mailto:" + MAIL + "?subject=" + encodeURIComponent(tr("title")) + "&body=" + encodeURIComponent(text); }
  function askText(k) { return tr("msg_step") + " «" + stepTitle(k) + "».\n" + summaryText(); }
  function quoteText() { return tr("msg_hello") + "\n" + summaryText(); }

  /* ---------- events ---------- */
  function setHeads(kind, n) {
    var list = st[kind];
    if (n === 0) { st[kind + "G"] = rowsOf(kind); list.length = 0; return; }
    if (!list.length) {
      // from a gravity drill to heads: spread its rows over ⌈rows/8⌉ heads as a starting point
      var rows = st[kind + "G"], m = Math.max(n, Math.ceil(rows / 8));
      for (var i = 0; i < m; i++) list.push({ o: Math.floor(rows / m) + (i < rows % m ? 1 : 0), c: [] });
      list.length = n === 1 && m > 1 ? m : n;
      return;
    }
    var o = list[list.length - 1].o;
    while (list.length < n) list.push({ o: o, c: [] });
    list.length = n;
  }
  function setOutlets(h, o) { h.o = o; h.c = h.c.filter(function (i) { return i < o; }); if (h.c.length >= o) h.c = h.c.slice(0, o - 1); }

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-open],[data-set],[data-step],[data-pick],[data-outlet],[data-act]");
    if (!t) return;
    if (t.dataset.open) { openStep(ui.open === t.dataset.open ? "" : t.dataset.open); var hd = document.getElementById("sh-" + t.dataset.open); if (hd) hd.focus(); return; }
    if (t.dataset.set) {
      if (t.getAttribute("aria-disabled") === "true") return;
      var v = t.dataset.val; st[t.dataset.set] = /^\d+$/.test(v) ? +v : v;
      if (t.dataset.set === "machine" && minHeads() > 0) { if (!st.seed.length) setHeads("seed", 1); if (!st.fert.length) setHeads("fert", 1); }
      track("change", { field: t.dataset.set, value: v });
      if (v === "unknown") track("unknown", { field: t.dataset.set, step: ui.open });
      render(); return;
    }
    if (t.dataset.step) {
      var parts = t.dataset.step.split("-"), kind = parts[0], what = parts[1], d = +t.dataset.d, list = st[kind];
      if (kind === "aux") {
        st[what] = Math.max(0, Math.min({ shafts: 6, hop: 3, turb: 2 }[what], st[what] + d));
        track("change", { field: "aux_" + what, value: st[what] }); render(); return;
      }
      if (what === "n") setHeads(kind, Math.max(minHeads(), Math.min(16, list.length + d)));
      if (what === "rows") st[kind + "G"] = Math.max(1, Math.min(150, st[kind + "G"] + d));
      track("change", { field: kind + "_" + what, value: rowsOf(kind) });
      if (what === "each") { var base = list[0].o; list.forEach(function (h) { setOutlets(h, Math.max(1, Math.min(48, base + d))); }); }
      if (what === "one") { var h = list[ui.sel[kind]]; setOutlets(h, Math.max(1, Math.min(48, h.o + d))); }
      render(); return;
    }
    if (t.dataset.pick) { ui.sel[t.dataset.pick] = +t.dataset.i; render(); return; }
    if (t.dataset.outlet != null) { toggleOutlet(t); return; }
    var a = t.dataset.act;
    if (a === "next") { var l = steps(); openStep(l[Math.min(l.length - 1, l.indexOf(ui.open) + 1)]); var n2 = document.getElementById("sh-" + ui.open); if (n2) n2.scrollIntoView({ block: "nearest" }); return; }
    if (a === "cart") {
      if (t.getAttribute("aria-disabled") === "true") return;
      var bom = R.compose(pricedOf(st)).bom, check = checks(R.compose(cfgOf(st)));
      track("cart", { total: priceOf(st), config: token(st), check: check.join(",") });
      if (SITE) { addToCart(bom, t, check); return; }
      sheet(tr("b_cart"), tr("cart_mock"), bom.map(function (l) { return l.qty + " × " + partName(l.sku) + "  (" + l.sku + ")  " + money(PRICES[l.sku] * l.qty); }).join("\n") +
        "\n— " + tr("s_total") + ": " + money(priceOf(st)) + "\n\n" + tr("msg_link") + ": " + PAGE_URL + "#" + token(st) +
        (check.length ? "\n" + tr("prop_check") + ": " + check.map(function (q) { return tr("q_" + q); }).join(" ") : ""));
      return;
    }
    // the WhatsApp button of the summary is a question about the whole kit: wizard_ask on step "summary" (contract 23.10)
    if (a === "quote") { track("ask", { step: "summary", config: token(st) }); return; }   // the link itself opens WhatsApp
    if (a === "ask") { track("ask", { step: t.dataset.stepk, config: token(st) }); return; }
    if (a === "speed") { ui.speedOpen = true; render(); return; }
    if (a === "info") { ui.shaftInfo = !ui.shaftInfo; render(); return; }
    if (a === "hub") { showHub(); return; }
    if (a === "share") { track("share", { config: token(st) }); sheet(tr("b_share"), "", PAGE_URL + "#" + token(st)); return; }
    if (a === "copy") {
      var pre = document.getElementById("msg");
      var done = function () { t.textContent = tr("b_copied"); };
      try { navigator.clipboard.writeText(pre.textContent).then(done, function () { selectPre(pre); }); } catch (err) { selectPre(pre); }
      return;
    }
    if (a === "close") { document.getElementById("modal").hidden = true; return; }
  });
  // Every part goes to the cart as its own shop line; the configuration link rides on each line as a property.
  function addToCart(bom, btn, check) {
    var prop = {}; prop[tr("msg_link")] = PAGE_URL + "#" + token(st);
    if (check.length) prop[tr("prop_check")] = check.map(function (q) { return tr("q_" + q); }).join(" ");
    btn.setAttribute("aria-disabled", "true");
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: bom.filter(function (l) { return VARIANT[l.sku]; }).map(function (l) { return { id: VARIANT[l.sku], quantity: l.qty, properties: prop }; }) })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); location.href = SITE.cartUrl || "/cart"; })
      .catch(function () { btn.removeAttribute("aria-disabled"); sheet(tr("b_cart"), tr("cart_error"), null); });
  }

  // Which way the visitor moves through the steps: down to the finish, or back up to change something.
  function openStep(k) {
    var l = steps(), from = l.indexOf(ui.open), to = l.indexOf(k);
    if (k) {
      track("step", { step: k, index: to + 1, direction: from < 0 ? "open" : to > from ? "down" : "up" });
      visit.step = k; visit.index = to + 1;
      if (k === "summary") visit.price = true;   // the part list with prices is in the summary
    }
    ui.open = k; render();
  }
  function selectPre(pre) { var r = document.createRange(); r.selectNodeContents(pre); var s = getSelection(); s.removeAllRanges(); s.addRange(r); }
  function toggleOutlet(g) {
    var kind = g.closest(".head-editor").classList.contains("fert") ? "fert" : "seed";
    var h = st[kind][ui.sel[kind]], i = +g.dataset.outlet, at = h.c.indexOf(i);
    if (at >= 0) h.c.splice(at, 1); else if (h.c.length < h.o - 1) h.c.push(i);
    h.c.sort(function (a, b) { return a - b; });
    render();
    var again = document.querySelector('.head-editor [data-outlet="' + i + '"]'); if (again) again.focus();
  }
  document.addEventListener("keydown", function (e) {
    if ((e.key === "Enter" || e.key === " ") && e.target.dataset && e.target.dataset.outlet != null) { e.preventDefault(); toggleOutlet(e.target); }
    if (e.key === "Escape") document.getElementById("modal").hidden = true;
  });
  document.getElementById("modal").addEventListener("click", function (e) { if (e.target.id === "modal") e.currentTarget.hidden = true; });
  document.addEventListener("input", function (e) {
    if (e.target.id === "in-width") { st.width = e.target.value; render(); }
    if (e.target.id === "in-spacing") { st.spacing = e.target.value; render(); }
  });
  // Part list ↔ drawing: pointing at a line lights that part on the machine.
  function hl(sku) {
    var plan = document.getElementById("plan");
    plan.classList.toggle("hl", !!sku);
    plan.querySelectorAll(".on").forEach(function (el) { el.classList.remove("on"); });
    if (sku) plan.querySelectorAll('[data-sku~="' + sku + '"]').forEach(function (el) { el.classList.add("on"); });
  }
  document.addEventListener("mouseover", function (e) { var r = e.target.closest && e.target.closest("[data-hl]"); hl(r ? r.dataset.hl : null); });
  document.addEventListener("focusin", function (e) { var r = e.target.closest && e.target.closest("[data-hl]"); hl(r ? r.dataset.hl : null); });

  st = load();
  var sel = document.getElementById("lang");
  if (SITE) ui.lang = TEXT[SITE.lang] ? SITE.lang : "en";     // the site's own language switch decides
  else {
    sel.innerHTML = Object.keys(TEXT).map(function (k) { return '<option value="' + k + '">' + TEXT[k].lang + "</option>"; }).join("");
    sel.addEventListener("change", function () { ui.lang = sel.value; render(); });
    var pref = null; try { pref = localStorage.getItem("aw-wizard-lang"); } catch (e) {}
    var nav = (navigator.language || "en").slice(0, 2).toLowerCase(); if (nav === "ru") nav = "uk";
    ui.lang = TEXT[pref] ? pref : TEXT[nav] ? nav : "en";
    sel.value = ui.lang;
  }
  render();
  loadAuxParts();
  track("view", { lang: ui.lang, from_link: !!location.hash });
  visit.step = ui.open; visit.index = steps().indexOf(ui.open) + 1;
})();
